import { jsxs as d, jsx as e, Fragment as G } from "react/jsx-runtime";
import f from "react";
import * as x from "@radix-ui/react-navigation-menu";
import { KeyboardArrowDown as O } from "@mui/icons-material";
import o from "@emotion/styled";
import { N as j } from "./navigationData-tFNNVAXI.js";
import * as $ from "@radix-ui/react-accordion";
const c = (r, i) => ({
  [r]: i
}), V = "#0bd1c2", D = (r, i) => {
  const n = parseInt(r.slice(1, 3), 16), l = parseInt(r.slice(3, 5), 16), s = parseInt(r.slice(5, 7), 16);
  return `rgba(${n}, ${l}, ${s}, ${i})`;
}, U = o(x.Root)({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  minWidth: 0,
  zIndex: 2
}), Y = o(x.List)({
  display: "flex",
  listStyle: "none",
  padding: 0,
  margin: 0,
  gap: "6px",
  alignItems: "center"
}), P = (r) => o(x.Trigger)({
  all: "unset",
  borderRadius: 9999,
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "6px 12px",
  color: r,
  fontWeight: 600,
  fontSize: "0.95rem",
  cursor: "pointer",
  transition: "background-color 150ms ease, color 150ms ease",
  "&:hover": {
    backgroundColor: D(r, 0.1)
  },
  "&[data-state='open']": {
    backgroundColor: D(r, 0.16)
  },
  "&:focus-visible": {
    outline: `2px solid ${r}`,
    outlineOffset: 2
  },
  "& svg": {
    transition: "transform 150ms ease"
  },
  "&[data-state='open'] svg": {
    transform: "rotate(180deg)"
  }
}), K = (r, i) => o(r)({
  borderRadius: 9999,
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  padding: "6px 12px",
  color: i,
  fontWeight: 600,
  fontSize: "0.95rem",
  cursor: "pointer",
  textDecoration: "none",
  transition: "background-color 150ms ease, color 150ms ease",
  "&:link, &:visited, &:active": {
    color: `${i} !important`
  },
  "&:hover": {
    backgroundColor: D(i, 0.1)
  },
  "&:focus-visible": {
    outline: `2px solid ${i}`,
    outlineOffset: 2
  }
}), X = o(x.Content)({
  width: "min(720px, calc(100vw - 48px))",
  backgroundColor: "#fff",
  borderRadius: 8,
  padding: "24px",
  boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  "&[data-variant='list']": {
    width: "min(440px, calc(100vw - 48px))"
  }
}), q = o("div")({
  display: "flex",
  flexDirection: "column",
  gap: "4px"
}), J = o("span")({
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: 1,
  color: "rgba(0, 0, 0, 0.6)"
}), Q = o("h3")({
  margin: 0,
  fontSize: "1.15rem",
  fontWeight: 700,
  color: "rgba(0, 0, 0, 0.87)"
}), Z = o("div")({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "12px"
}), E = (r) => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  padding: "14.4px",
  borderRadius: 16,
  textDecoration: "none",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  backgroundColor: "rgba(250, 250, 250, 0.9)",
  color: "rgba(0, 0, 0, 0.87)",
  transition: "border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease",
  "&:hover": {
    borderColor: r,
    transform: "translateY(-2px)",
    boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
  }
}), rr = (r, i) => o(r)(E(i)), er = (r) => o("div")({
  ...E(r),
  textDecoration: "none",
  cursor: "default",
  "&:hover": {
    borderColor: "rgba(0, 0, 0, 0.12)",
    transform: "none",
    boxShadow: "none"
  }
}), or = o("div")({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "8px",
  flexWrap: "wrap"
}), ir = o("span")({
  fontWeight: 600,
  fontSize: "0.95rem",
  color: "rgba(0, 0, 0, 0.87)"
}), nr = o("p")({
  margin: 0,
  fontSize: "0.85rem",
  lineHeight: 1.4,
  color: "rgba(0, 0, 0, 0.8)"
}), ar = o("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  justifyContent: "flex-end"
}), tr = (r) => ({
  fontSize: "14px",
  lineHeight: 1.2,
  padding: "4px 12px",
  borderRadius: 9999,
  backgroundColor: "rgba(250, 250, 250, 0.9)",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  color: r,
  fontWeight: 600,
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  transition: "border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease",
  cursor: "pointer",
  "&:link, &:visited, &:active": {
    color: `${r} !important`,
    borderColor: "rgba(0, 0, 0, 0.12)"
  },
  "&:hover": {
    borderColor: r,
    transform: "translateY(-2px)",
    boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
  },
  "&:focus-visible": {
    outline: `2px solid ${r}`,
    outlineOffset: 2
  }
}), sr = (r) => o("span")({
  ...tr(r),
  cursor: "inherit",
  "&:hover": {}
}), dr = o("div")({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  columnGap: "18px",
  rowGap: "6px"
}), lr = (r, i) => o(r)({
  alignItems: "center",
  backgroundColor: "rgba(250, 250, 250, 0.9)",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  borderRadius: 9999,
  color: i,
  display: "inline-flex",
  fontSize: "0.9rem",
  fontWeight: 600,
  justifyContent: "center",
  lineHeight: 1.3,
  minHeight: 28,
  padding: "4px 12px",
  textDecoration: "none",
  transition: "background-color 150ms ease, border-color 150ms ease",
  "&:link, &:visited, &:active": {
    color: `${i} !important`,
    borderColor: "rgba(0, 0, 0, 0.12)"
  },
  "&:hover": {
    backgroundColor: D(i, 0.08),
    borderColor: i
  },
  "&:focus-visible": {
    outline: `2px solid ${i}`,
    outlineOffset: 2
  }
}), pr = o("div")({
  display: "flex",
  flexDirection: "column",
  gap: "10px"
}), cr = (r, i) => o(r)({
  display: "flex",
  flexDirection: "column",
  textDecoration: "none",
  padding: "10px 12px",
  borderRadius: 14,
  border: "1px solid rgba(0, 0, 0, 0.12)",
  transition: "border-color 150ms ease, transform 150ms ease",
  color: "rgba(0, 0, 0, 0.87)",
  "&:hover": {
    borderColor: i,
    transform: "translateY(-1px)"
  }
}), xr = o("div")({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  padding: "10px 12px",
  borderRadius: 14,
  border: "1px solid rgba(0, 0, 0, 0.12)"
}), gr = (r, i) => o(r)({
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  textDecoration: "none",
  color: "rgba(0, 0, 0, 0.87)",
  "&:hover span:first-of-type": {
    color: i
  }
}), W = o("span")({
  fontWeight: 600,
  fontSize: "0.95rem",
  color: "rgba(0, 0, 0, 0.87)"
}), C = o("span")({
  fontSize: "0.85rem",
  color: "rgba(0, 0, 0, 0.72)"
}), br = o("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "6px"
}), fr = o("div")({
  position: "absolute",
  display: "flex",
  justifyContent: "flex-end",
  width: "100%",
  top: "calc(100% + 10px)",
  pointerEvents: "none"
}), hr = o(x.Viewport)({
  position: "relative",
  transformOrigin: "top center",
  transition: "width 200ms ease, height 200ms ease, opacity 150ms ease, transform 200ms ease",
  backgroundColor: "#fff",
  borderRadius: 8,
  boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
  overflow: "hidden",
  pointerEvents: "auto",
  flex: "none",
  minWidth: "var(--radix-navigation-menu-viewport-width)",
  width: "var(--radix-navigation-menu-viewport-width)",
  height: "var(--radix-navigation-menu-viewport-height)"
}), Nr = ({
  LinkComponent: r,
  linkProp: i,
  accentColor: n = V
}) => {
  const l = f.useMemo(
    () => P(n),
    [n]
  ), s = f.useMemo(
    () => K(r, n),
    [r, n]
  ), t = f.useMemo(
    () => rr(r, n),
    [r, n]
  ), m = f.useMemo(
    () => er(n),
    [n]
  ), v = f.useMemo(
    () => sr(n),
    [n]
  ), g = f.useMemo(
    () => lr(r, n),
    [r, n]
  ), w = f.useMemo(
    () => cr(r, n),
    [r, n]
  ), y = f.useMemo(
    () => gr(r, n),
    [r, n]
  );
  return /* @__PURE__ */ d(U, { "aria-label": "Programs navigation", children: [
    /* @__PURE__ */ e(Y, { children: j.map((p) => p.variant === "link" && p.items[0] ? /* @__PURE__ */ e(x.Item, { children: /* @__PURE__ */ e(x.Link, { asChild: !0, children: /* @__PURE__ */ e(
      s,
      {
        ...c(i, p.items[0].href),
        children: p.label
      }
    ) }) }, p.label) : /* @__PURE__ */ d(x.Item, { children: [
      /* @__PURE__ */ d(l, { children: [
        p.label,
        /* @__PURE__ */ e(O, { fontSize: "inherit" })
      ] }),
      /* @__PURE__ */ d(X, { "data-variant": p.variant ?? "cards", children: [
        /* @__PURE__ */ d(q, { children: [
          p.eyebrow ? /* @__PURE__ */ e(J, { children: p.eyebrow }) : null,
          /* @__PURE__ */ e(Q, { children: p.label })
        ] }),
        p.variant === "list" ? /* @__PURE__ */ e(pr, { children: p.items.map((a) => {
          const h = a.subLinks ?? [];
          return h.length > 0 ? /* @__PURE__ */ d(xr, { children: [
            /* @__PURE__ */ e(x.Link, { asChild: !0, children: /* @__PURE__ */ d(
              y,
              {
                ...c(i, a.href),
                children: [
                  /* @__PURE__ */ e(W, { children: a.label }),
                  a.description ? /* @__PURE__ */ e(C, { children: a.description }) : null
                ]
              }
            ) }),
            /* @__PURE__ */ e(br, { children: h.map((b) => /* @__PURE__ */ e(
              g,
              {
                ...c(i, b.href),
                children: b.label
              },
              b.href
            )) })
          ] }, a.href) : /* @__PURE__ */ e(x.Link, { asChild: !0, children: /* @__PURE__ */ d(w, { ...c(i, a.href), children: [
            /* @__PURE__ */ e(W, { children: a.label }),
            a.description ? /* @__PURE__ */ e(C, { children: a.description }) : null
          ] }) }, a.href);
        }) }) : /* @__PURE__ */ e(Z, { children: p.items.map((a) => {
          const h = a.subLinks ?? [], b = h.length > 0, M = b ? m : t, S = a.badges?.length ? a.badges.map((k, L) => {
            const F = h[L]?.href ?? a.href;
            return b ? /* @__PURE__ */ e(
              g,
              {
                ...c(i, F),
                children: k
              },
              `${a.href}-${k}-${L}`
            ) : /* @__PURE__ */ e(
              v,
              {
                children: k
              },
              `${a.href}-${k}-${L}`
            );
          }) : null, T = /* @__PURE__ */ d(G, { children: [
            /* @__PURE__ */ d(or, { children: [
              /* @__PURE__ */ e(ir, { children: a.label }),
              !b && S ? /* @__PURE__ */ e(ar, { children: S }) : null
            ] }),
            a.description ? /* @__PURE__ */ e(nr, { children: a.description }) : null,
            b && S ? /* @__PURE__ */ e(dr, { children: S }) : null
          ] });
          return b ? /* @__PURE__ */ e(M, { children: T }, a.href) : /* @__PURE__ */ e(x.Link, { asChild: !0, children: /* @__PURE__ */ e(M, { ...c(i, a.href), children: T }) }, a.href);
        }) })
      ] })
    ] }, p.label)) }),
    /* @__PURE__ */ e(fr, { children: /* @__PURE__ */ e(hr, {}) })
  ] });
}, ur = "#0bd1c2", mr = 320, vr = 12, z = 14, I = (r, i) => {
  const n = parseInt(r.slice(1, 3), 16), l = parseInt(r.slice(3, 5), 16), s = parseInt(r.slice(5, 7), 16);
  return `rgba(${n}, ${l}, ${s}, ${i})`;
}, wr = o("div")({
  boxSizing: "border-box",
  width: `min(${mr}px, 50vw)`
}), yr = o($.Root)({
  width: "100%"
}), Sr = o($.Item)({
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)"
}), u = (r) => r !== "accentColor", kr = o($.Trigger, {
  shouldForwardProp: u
})(({ accentColor: r }) => ({
  all: "unset",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxSizing: "border-box",
  padding: `16px ${z}px`,
  fontSize: "1rem",
  fontWeight: 600,
  color: "rgba(0, 0, 0, 0.87)",
  cursor: "pointer",
  backgroundColor: "transparent",
  transition: "background-color 150ms ease",
  "&:hover": {
    backgroundColor: I(r, 0.05)
  },
  "& svg": {
    transition: "transform 200ms ease"
  },
  "&[data-state='open'] svg": {
    transform: "rotate(180deg)"
  }
})), Dr = o($.Content)({
  overflow: "hidden",
  backgroundColor: "rgba(250, 250, 250, 0.5)",
  '&[data-state="open"]': {
    animation: "slideDown 200ms ease"
  },
  '&[data-state="closed"]': {
    animation: "slideUp 200ms ease"
  },
  "@keyframes slideDown": {
    from: {
      height: 0
    },
    to: {
      height: "var(--radix-accordion-content-height)"
    }
  },
  "@keyframes slideUp": {
    from: {
      height: "var(--radix-accordion-content-height)"
    },
    to: {
      height: 0
    }
  }
}), $r = o("div")({
  boxSizing: "border-box",
  padding: "8px 0 16px 0"
}), Lr = o("div")({
  boxSizing: "border-box",
  padding: `12px ${z}px`,
  overflowWrap: "anywhere",
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: 1,
  color: "rgba(0, 0, 0, 0.5)"
}), R = o("a", {
  shouldForwardProp: u
})(({ accentColor: r }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  boxSizing: "border-box",
  padding: `12px ${vr}px`,
  textDecoration: "none",
  color: "rgba(0, 0, 0, 0.87)",
  borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
  transition: "background-color 150ms ease",
  "&:hover": {
    backgroundColor: I(r, 0.08)
  },
  "&:last-child": {
    borderBottom: "none"
  }
})), zr = o("a", {
  shouldForwardProp: u
})(({ accentColor: r }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  textDecoration: "none",
  color: "rgba(0, 0, 0, 0.87)",
  "&:hover div:first-of-type": {
    color: r
  }
})), N = o("div")({
  fontWeight: 600,
  fontSize: "0.95rem",
  color: "rgba(0, 0, 0, 0.87)"
}), A = o("div")({
  fontSize: "0.85rem",
  lineHeight: 1.4,
  color: "rgba(0, 0, 0, 0.7)"
}), H = o("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  marginTop: "4px"
}), _ = o("a", {
  shouldForwardProp: u
})(({ accentColor: r }) => ({
  fontSize: "14px",
  lineHeight: 1.2,
  padding: "4px 12px",
  borderRadius: 9999,
  backgroundColor: "rgba(250, 250, 250, 0.9)",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  color: r,
  fontWeight: 600,
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  transition: "border-color 150ms ease, transform 150ms ease, box-shadow 150ms ease",
  "&:link, &:visited, &:active": {
    color: `${r} !important`,
    borderColor: "rgba(0, 0, 0, 0.12)"
  },
  "&:hover": {
    borderColor: r,
    transform: "translateY(-2px)",
    boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
  },
  "&:focus-visible": {
    outline: `2px solid ${r}`,
    outlineOffset: 2
  }
})), B = o("a", {
  shouldForwardProp: u
})(({ accentColor: r }) => ({
  display: "block",
  boxSizing: "border-box",
  padding: `16px ${z}px`,
  fontSize: "1rem",
  fontWeight: 600,
  color: "rgba(0, 0, 0, 0.87)",
  textDecoration: "none",
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  transition: "background-color 150ms ease",
  "&:link, &:visited, &:active": {
    color: "rgba(0, 0, 0, 0.87) !important"
  },
  "&:hover": {
    backgroundColor: I(r, 0.05)
  }
})), Ir = (r) => r.toLowerCase().replace(/\s+/g, "-"), Ar = ({
  LinkComponent: r,
  linkProp: i,
  handleRouteClicked: n,
  accentColor: l = ur
}) => /* @__PURE__ */ d(wr, { children: [
  /* @__PURE__ */ e(
    B,
    {
      as: r,
      accentColor: l,
      ...c(i, "/"),
      onClick: () => n("/"),
      children: "Home"
    }
  ),
  /* @__PURE__ */ e(yr, { type: "multiple", children: j.map((s) => s.variant === "link" && s.items[0] ? /* @__PURE__ */ e(
    B,
    {
      as: r,
      accentColor: l,
      ...c(i, s.items[0].href),
      onClick: () => n(s.items[0].href),
      children: s.label
    },
    s.label
  ) : /* @__PURE__ */ d(
    Sr,
    {
      value: Ir(s.label),
      children: [
        /* @__PURE__ */ d(kr, { accentColor: l, children: [
          s.label,
          /* @__PURE__ */ e(O, { fontSize: "small" })
        ] }),
        /* @__PURE__ */ e(Dr, { children: /* @__PURE__ */ d($r, { children: [
          s.eyebrow ? /* @__PURE__ */ e(Lr, { children: s.eyebrow }) : null,
          s.items.map((t) => {
            const m = t.badges ?? [], v = t.subLinks ?? [];
            return v.length > 0 ? /* @__PURE__ */ d(
              R,
              {
                as: "div",
                accentColor: l,
                children: [
                  /* @__PURE__ */ d(
                    zr,
                    {
                      as: r,
                      accentColor: l,
                      ...c(i, t.href),
                      onClick: () => n(t.href),
                      children: [
                        /* @__PURE__ */ e(N, { children: t.label }),
                        t.description ? /* @__PURE__ */ e(A, { children: t.description }) : null
                      ]
                    }
                  ),
                  /* @__PURE__ */ e(H, { children: v.map((g) => /* @__PURE__ */ e(
                    _,
                    {
                      as: r,
                      accentColor: l,
                      ...c(i, g.href),
                      onClick: () => n(g.href),
                      children: g.label
                    },
                    g.href
                  )) })
                ]
              },
              t.href
            ) : /* @__PURE__ */ d(
              R,
              {
                as: r,
                accentColor: l,
                ...c(i, t.href),
                onClick: () => n(t.href),
                children: [
                  /* @__PURE__ */ e(N, { children: t.label }),
                  t.description ? /* @__PURE__ */ e(A, { children: t.description }) : null,
                  m.length ? /* @__PURE__ */ e(H, { children: m.map((g, w) => {
                    const y = t.subLinks?.[w]?.href ?? t.href;
                    return /* @__PURE__ */ e(
                      _,
                      {
                        as: r,
                        accentColor: l,
                        ...c(i, y),
                        onClick: () => n(y),
                        children: g
                      },
                      `${t.href}-${g}-${w}`
                    );
                  }) }) : null
                ]
              },
              t.href
            );
          })
        ] }) })
      ]
    },
    s.label
  )) })
] });
export {
  Nr as R,
  Ar as a
};
